import React, { forwardRef, TextareaHTMLAttributes } from 'react'
import styles from './TextArea.module.scss'
import Icon from '@/components/UI/icon/Icon'

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: boolean
  description?: string
  data_cy?: string
}
const TextArea = forwardRef(function TextAreaFieldset(
  {
    label,
    error,
    description,
    disabled = false,
    placeholder = '',
    className = '',
    data_cy,
    ...props
  }: TextAreaProps,
  ref: React.ForwardedRef<HTMLTextAreaElement>,
) {
  return (
    <div
      data-cy={data_cy}
      className={`${styles['container']} ${error ? styles['error'] : ''} ${disabled ? styles['disabled'] : ''} ${className}`}
    >
      <div className={styles['input-container']}>
        <textarea
          ref={ref}
          className={styles['textarea']}
          disabled={disabled}
          placeholder=""
          {...props}
        />
        <label className={styles['label']}>{label}</label>
        <fieldset className={styles['fieldset']}>
          <legend className={styles['legend']}>{label}</legend>
        </fieldset>
      </div>
      {description && (
        <div className={styles['description']}>
          <Icon name={'info-circle'} type={'inherit'} size={'xSmall'} />
          <span>{description}</span>
        </div>
      )}
    </div>
  )
})
export default TextArea
